import { FC, SVGProps } from "react";

const Star: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 22 22" fill="currentcolor" {...props}>
      <path
        d="M12.2187 0.000423596L13.8051 7.64737L21.1936 9.88235L14.4128 13.6465L14.5316 21.4245L8.77253 16.2132L1.36926 18.7375L4.64138 11.6802L0.000359129 5.3776L7.65909 6.34099L12.2187 0.000423596Z"
      />
    </svg>
  );
};

export default Star;
